import * as React from 'react';

import type { EoiStateOverrides, EoiStateVariants } from 'bundles/degree-description/utils/experiments';

export type DegreeDescriptionEoiStateContextType = {
  eoiStates: [eoiStateVarState?: EoiStateVariants, setEoiStateVarState?: (eoiState: EoiStateVariants) => void];
  variantOverrides: [
    showVariantOverrides?: EoiStateOverrides,
    setShowVariantOverrides?: (overrides: EoiStateOverrides) => void
  ];
};

export const DegreeDescriptionEoiStateContext = React.createContext<DegreeDescriptionEoiStateContextType | undefined>(
  undefined
);

export const useDegreeDescriptionEoiStateContext = () => {
  const context = React.useContext(DegreeDescriptionEoiStateContext);
  if (!context)
    throw new Error('useDegreeDescriptionEoiStateContext was used outside of DegreeDescriptionEoiStateContext');
  return context;
};

export default DegreeDescriptionEoiStateContext;
